import { RequestActions } from '../../core/api/state';

const actions = {
  LOAD_CROPWISE_USER: new RequestActions('[User] Load Cropwise User'),
  SET_USER_CURRENT_WORKSPACE: '[User] Set User Current Workspace',
  UPADTE_USER_PREFERENCES: '[User] Update user preferences',
  setUserCurrentWorkspace: (id: string) => ({
    type: actions.SET_USER_CURRENT_WORKSPACE,
    payload: id,
  }),
};

export default actions;
